import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { CheckInForm } from "../components";
import { useCheckInData, useCheckInForm, useCheckInSubmit } from "../hooks";

export function CheckInFormPage() {
	const { user } = useAuth();
	const navigate = useNavigate();

	const { reflections, loading } = useCheckInData(user?.id);
	const {
		generalFeeling,
		setGeneralFeeling,
		dayDescription,
		setDayDescription,
		selectedReflections,
		setSelectedReflections,
		reflectionResponses,
		setReflectionResponses,
		isFormValid,
		resetForm,
	} = useCheckInForm();

	const handleCheckInSuccess = () => {
		resetForm();
		navigate("/daily-checkin/complete", { state: { justSubmitted: true } });
	};

	const { submitting, submitCheckIn } = useCheckInSubmit({
		userId: user?.id,
		onSuccess: handleCheckInSuccess,
	});

	const handleSubmit = () => {
		submitCheckIn({
			generalFeeling,
			dayDescription,
			selectedReflections,
			reflectionResponses,
		});
	};

	const handleBack = () => {
		navigate("/daily-checkin");
	};

	if (!user || loading) {
		return (
			<div className="container mx-auto px-4 py-8">
				<div className="flex items-center justify-center h-64">
					<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
				</div>
			</div>
		);
	}

	return (
		<div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
			<div className="container mx-auto px-4 py-6 sm:py-8 max-w-7xl">
				<CheckInForm
					generalFeeling={generalFeeling}
					setGeneralFeeling={setGeneralFeeling}
					dayDescription={dayDescription}
					setDayDescription={setDayDescription}
					reflections={reflections}
					selectedReflections={selectedReflections}
					setSelectedReflections={setSelectedReflections}
					reflectionResponses={reflectionResponses}
					setReflectionResponses={setReflectionResponses}
					onBack={handleBack}
					onSubmit={handleSubmit}
					submitting={submitting}
					isFormValid={isFormValid}
				/>
			</div>
		</div>
	);
}
